import ApiEndpoint from "../../common";
export const clientsPoint = { list: ApiEndpoint + "clients" };
